import {

    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";
import { updateOrder, UpdateOrderApiParameter } from "@insite/client-framework/Services/OrderService";

import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import loadOrderByOrderNumberCustom from "@WhiteCap/Handlers/OrderDetails/LoadOrderbyOrderNumberCustom";
import { CustomApiHandlerDiscreteParameter } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getOrderDetailsState } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderDeatilsCustom/OrderDetailsCustomSelector";

type Parameter = { orderNumber: string };
type HandlerType = CustomApiHandlerDiscreteParameter<Parameter, UpdateOrderApiParameter, OrderModel>;

const CANCEL_STATUS = "CancellationRequested";

export const DispatchBeginCancelOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/BeginCancelOrder",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const order = getOrderDetailsState(state, props.parameter.orderNumber);
    if (!order.value) {
        throw new Error("CancelOrder was called but there was no order");
    }

    props.apiParameter = {
        order: {
            ...order.value,
            status: CANCEL_STATUS,
        },
    };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await updateOrder(props.apiParameter);
};

export const DispatchCompleteCancelOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderDetails/CompleteCancelOrder",
    });
    props.dispatch(
        loadOrderByOrderNumberCustom({
            orderNumber: props.apiResult.webOrderNumber || props.apiResult.erpOrderNumber,
            expand: props.apiResult.vmiLocationId
                ? ["orderLines", "shipments", "vmidetails"]
                : ["orderLines", "shipments"],
        }),
    );
};

export const chain = [DispatchBeginCancelOrder, PopulateApiParameter, SendDataToApi, DispatchCompleteCancelOrder];

const cancelOrderCustom = createHandlerChainRunnerOptionalParameter(chain, { orderNumber: "" }, "CancelOrderCustom");
export default cancelOrderCustom;
